import { ComponentType, FC, useMemo } from 'react';

import {
	DBObservableDataContextProvider,
	IDBObservableDataContext,
	useUser$,
} from '@mopla/business-logic';
import { wrapDisplayName } from '@mopla/utils';

export const withDBObservableDataContext = (
	WrappedComponent: ComponentType
) => {
	const Wrapper: FC = () => {
		const user$ = useUser$();

		const ctx = useMemo<IDBObservableDataContext>(() => ({ user$ }), [user$]);

		return (
			<DBObservableDataContextProvider value={ctx}>
				<WrappedComponent />
			</DBObservableDataContextProvider>
		);
	};

	Wrapper.displayName = wrapDisplayName(
		WrappedComponent,
		'withDBObservableData'
	);

	return Wrapper;
};
